import { FieldFilter } from 'components/organisms/tasks/filters';
import { SelectFilterOperationType } from 'components/organisms/tasks/filters/select';
import { SingleSelectFieldFilter } from 'components/organisms/tasks/filters/single-select';
import { GroupedFilter } from 'components/organisms/tasks/grouped-filter-popover';
import { FilterGroupType } from 'components/pages/types';

export const getRolesFromFilter = (filter: GroupedFilter): number[] => {
  const roleFilters = filter.groupCriteria.filter(
    ({ id, criteria }) =>
      id === FilterGroupType.User &&
      FieldFilter.isValid(criteria) &&
      criteria.field.fieldName === 'role',
  );

  if (roleFilters.length !== 1) {
    return [];
  }
  const firstRoleFilter = roleFilters[0].criteria as SingleSelectFieldFilter;

  switch (firstRoleFilter.type) {
    case SelectFilterOperationType.Is:
      return firstRoleFilter.value != null ? [firstRoleFilter.value] : [];
    case SelectFilterOperationType.IsOneOf:
      return firstRoleFilter.value ?? [];
    default:
      return [];
  }
};
